(() => {
  if (window.hmFitGuide) return;
  window.hmFitGuide = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const KEY = 'hmFitSize';
  const BANDS = [
    { k: 'S', name: 'Narrow', max: 132 },
    { k: 'M', name: 'Medium', max: 140 },
    { k: 'L', name: 'Wide', max: 148 },
    { k: 'XL', name: 'Extra wide', max: Infinity },
  ];
  const FACE_NAMES = { oval: 'oval', round: 'round', square: 'square', heart: 'heart', oblong: 'oblong' };

  const bandOf = total => BANDS.findIndex(b => total <= b.max);

  // "61-14mm", "54□18", "54-19 mm", "54mm", "140mm" (shield = whole frame width)
  const parseSize = raw => {
    const s = String(raw || '').replace(/ /g, ' ');
    const pair = s.match(/(\d{2,3})\s*(?:mm)?\s*[-–—x×□\/ ]\s*(\d{1,2})(?!\d)/);
    const one = s.match(/(\d{2,3})\s*mm/i) || s.match(/^\s*(\d{2,3})\s*$/);
    const lens = pair ? +pair[1] : one ? +one[1] : NaN;
    const bridge = pair ? +pair[2] : null;
    if (lens >= 40 && lens <= 75) {
      const total = 2 * lens + (bridge && bridge >= 10 && bridge <= 30 ? bridge : 18) + 10;
      return { lens, bridge, total, band: bandOf(total) };
    }
    if (lens >= 110 && lens <= 175) return { lens: null, bridge: null, total: lens, band: bandOf(lens) };
    return null;
  };

  const load = () => { try { const v = JSON.parse(localStorage.getItem(KEY)); return v && v.band >= 0 && v.band < 4 ? v : null; } catch { return null; } };
  const save = v => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch {} };

  const verdict = (frame, you) => {
    const d = frame - you;
    if (d === 0) return { ok: true, text: 'Matches your size' };
    if (d === 1) return { ok: true, text: 'A little wider than your size: a relaxed, oversized look' };
    if (d === -1) return { ok: true, text: 'A little narrower than your size: a snug fit' };
    return { ok: false, text: d > 0 ? 'Much wider than your size: may slide down' : 'Much narrower than your size: may pinch' };
  };

  const listFaces = keys => {
    const names = keys.map(k => FACE_NAMES[k]).filter(Boolean);
    if (names.length < 2) return names[0] || '';
    return names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1];
  };

  const listeners = new Set();
  const broadcast = () => listeners.forEach(fn => fn(load()));

  function initCalc(calc) {
    const result = $('[data-hm-fg-result]', calc);
    const tabs = $$('[data-hm-fg-method]', calc);
    const show = (you, how) => {
      const table = calc.parentElement && calc.parentElement.querySelector('.hm-fg-table');
      if (table) $$('[data-hm-fg-row]', table).forEach(r => r.classList.toggle('is-you', you && +r.dataset.hmFgRow === you.band));
      if (!you) { result.textContent = ''; return; }
      const b = BANDS[you.band];
      result.innerHTML = `Your size: <b>${b.k} · ${b.name}</b>${how ? ` <span>${how}</span>` : ''}`;
    };
    const set = (band, how, src) => {
      const v = { band, src };
      save(v);
      broadcast();
      show(v, how);
    };
    tabs.forEach(t => t.addEventListener('click', () => {
      tabs.forEach(o => o.setAttribute('aria-selected', o === t ? 'true' : 'false'));
      $$('[data-hm-fg-pane]', calc).forEach(p => { p.hidden = p.dataset.hmFgPane !== t.dataset.hmFgMethod; });
    }));
    const lens = $('[data-hm-fg-in="lens"]', calc), bridge = $('[data-hm-fg-in="bridge"]', calc), face = $('[data-hm-fg-in="face"]', calc);
    const onPair = () => {
      const p = parseSize(`${lens.value}-${bridge.value || 18}`);
      if (p) set(p.band, `(frame ≈ ${p.total} mm wide)`, 'pair');
    };
    lens.addEventListener('input', onPair);
    bridge.addEventListener('input', onPair);
    face.addEventListener('input', () => {
      const w = +face.value;
      if (w >= 100 && w <= 180) set(bandOf(w), '(pick frames about as wide as your face)', 'face');
    });
    $$('[data-hm-fg-card]', calc).forEach(btn => btn.addEventListener('click', () => {
      $$('[data-hm-fg-card]', calc).forEach(o => o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'));
      set(+btn.dataset.hmFgCard, '', 'card');
    }));
    const you = load();
    show(you, you ? '(saved from last time)' : '');
    listeners.add(v => show(v, ''));
  }

  function initPdp(root) {
    const section = root.closest('.shopify-section') || document;
    const dialog = $('[data-hm-fg-dialog]', root);
    const trigger = $('[data-hm-fg-open]', root);
    const summary = $('[data-hm-fg-summary]', root);
    const badge = $('[data-hm-fg-badge]', root);
    const frameBox = $('[data-hm-fg-frame]', root);
    const faces = (root.dataset.faces || '').split(',').filter(Boolean);
    const facesText = listFaces(faces);

    let variants = [];
    try { variants = JSON.parse($('[data-hm-fg-variants]', root).textContent); } catch {}
    let variantId = root.dataset.variant;
    const syncVariant = () => {
      const input = $('form input[name="id"]', section);
      if (input && input.value) variantId = input.value;
    };
    const currentSize = () => {
      const v = variants.find(x => String(x.id) === String(variantId));
      return v && v.size ? v.size : root.dataset.size;
    };

    const picked = $('[data-hm-fg-picked]', root);
    if (facesText && picked) {
      picked.hidden = false;
      picked.innerHTML = `This frame suits <b>${facesText}</b> faces.`;
      faces.forEach(f => { const li = $(`[data-face="${f}"]`, root); if (li) li.classList.add('is-match'); });
    }

    const render = () => {
      const raw = currentSize();
      const f = parseSize(raw);
      const you = load();
      badge.hidden = true;
      if (!f) {
        frameBox.hidden = true;
        summary.textContent = facesText ? `Suits ${facesText} faces · find your size` : 'Find your size and face shape';
        return;
      }
      const b = BANDS[f.band];
      frameBox.hidden = false;
      $('[data-hm-fg-frame-size]', frameBox).textContent = `${raw} · ≈ ${f.total} mm wide`;
      $$('[data-hm-fg-scale] > span', frameBox).forEach(s => {
        const i = +s.dataset.i;
        s.classList.toggle('is-frame', i === f.band);
        s.classList.toggle('is-you', !!you && i === you.band);
      });
      const vEl = $('[data-hm-fg-verdict]', frameBox);
      if (you) {
        const v = verdict(f.band, you.band);
        vEl.textContent = v.text;
        vEl.className = 'hm-fg-frame__verdict ' + (v.ok ? 'is-ok' : 'is-warn');
        summary.textContent = `${b.name} fit · ${v.text.split(':')[0].toLowerCase()}`;
        badge.textContent = v.ok ? '✓' : '!';
        badge.className = 'hm-fg-badge ' + (v.ok ? 'is-ok' : 'is-warn');
        badge.hidden = false;
      } else {
        vEl.textContent = 'Find your size below to see how this frame fits you.';
        vEl.className = 'hm-fg-frame__verdict';
        summary.textContent = `${b.k} · ${b.name} fit (≈ ${f.total} mm)` + (facesText ? ` · suits ${facesText} faces` : '');
      }
    };

    const tabs = $$('[role="tab"]', $('.hm-fg-tabs', dialog));
    const select = (tab, focus) => {
      tabs.forEach(t => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        $('#' + t.getAttribute('aria-controls'), dialog).hidden = !on;
      });
      $('.hm-fg-dialog__body', dialog).scrollTop = 0;
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', e => {
        const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        select(tabs[(i + d + tabs.length) % tabs.length], true);
      });
    });

    const close = () => dialog.close();
    trigger.addEventListener('click', e => {
      if (!dialog.showModal) return;
      e.preventDefault();
      syncVariant();
      render();
      dialog.showModal();
      document.documentElement.classList.add('hm-fg-lock');
    });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('hm-fg-lock'); trigger.focus({ preventScroll: true }); });
    $('[data-hm-fg-close]', dialog).addEventListener('click', close);
    dialog.addEventListener('click', e => { if (e.target === dialog) close(); });

    section.addEventListener('shopify:product:select', e => {
      const p = e.promise || Promise.resolve(null);
      p.then(r => {
        const res = r && r.detail && r.detail.resource;
        if (res && res.id) variantId = res.id; else syncVariant();
        render();
      }).catch(() => {});
    });
    listeners.add(render);
    render();
  }

  const once = fn => el => { if (el.dataset.hmFgReady) return; el.dataset.hmFgReady = '1'; fn(el); };
  const init = (scope = document) => {
    $$('[data-hm-fg-calc]', scope).forEach(once(initCalc));
    $$('[data-hm-fg-pdp]', scope).filter(el => !el.closest('.quick-add-modal')).forEach(once(initPdp));
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
